import { useMemo } from 'react';

import { appendUtmParams } from '../../utils/url';

/**
 * Renders an <a> tag that automatically appends stored UTM params
 * to the href. Use this instead of raw <a> for external links
 * so UTMs propagate without per-callsite logic.
 *
 * Usage:
 *   <ExternalLink href={SUPPORT_URL} target="_blank">
 *     Contact support
 *   </ExternalLink>
 */
const ExternalLink = ({ href, children, ...props }) => {
  const hrefWithUtms = useMemo(
    () => appendUtmParams(href),
    [href],
  );

  return (
    <a href={hrefWithUtms} {...props}>
      {children}
    </a>
  );
};

export default ExternalLink;
